import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { PageTitleService } from './page-title.service';

/**
 * Angular pone el título de la ruta tal cual en la pestaña. Acá no: se lo entrega a {@link PageTitleService}, que lo
 * combina con la empresa, la marca y el aviso de notificaciones, y deja que el encabezado de la pantalla lo precise.
 */
@Injectable({ providedIn: 'root' })
export class SoftRentTitleStrategy extends TitleStrategy {
  private titulos = inject(PageTitleService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.titulos.base(this.buildTitle(snapshot));
  }
}
